// extracted by mini-css-extract-plugin
module.exports = {"tableImg":"turnover-log_tableImg_3AGcD"};